import { useRef, useState } from 'react'

import { DSAccordion, DSCol, DSRow, DSTag, DSText } from '@vr/ds-react'

import { DeliveryUnitsProps } from './interface'
import { DeliveryUnitsList } from '../delivery-units-list'
import { STATUS_DELIVERY } from '@/constants/status-delivery'
import { useDeliveryContext } from '@/contexts/delivery.context'

export const DeliveryUnits = ({ data }: DeliveryUnitsProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [openCount, setOpenCount] = useState(0)
  const contentRef = useRef<HTMLDivElement>(null)
  const { setDelivery } = useDeliveryContext()

  const handleClick = () => {
    const willOpen = !isOpen
    setIsOpen(willOpen)
    if (willOpen) {
      setOpenCount(prev => prev + 1)
      setDelivery(data)
    }
  }

  const variant = STATUS_DELIVERY[data.status] ?? { style: 'outlined', label: '-' }

  return (
    <div
      onClick={handleClick}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleClick() }}
      role="button"
      tabIndex={0}
    >
      <DSAccordion
        defaultOpen={false}
        css={{
          marginTop: '16px',
          padding: '20px',
          border: '1px solid $ds-colors$neutralMedium',
          borderColor: data.status === 'recusado' && '$ds-colors$errorVeryDark',
          borderRadius: '8px'
        }}
      >
        <DSAccordion.Header>
          <DSRow wrap='wrap'>
            <DSCol
              xs={12}
              lg={4}
              gap={1}
              css={{ display: 'flex', flexDirection: 'column' }}
            >
              <DSText as='p'>Grupo</DSText>
              <DSText as='strong' weight='bold'>
                {data.nomeEmpregador}
              </DSText>
            </DSCol>
            <DSCol
              xs={12}
              lg={4}
              gap={1}
              css={{ display: 'flex', flexDirection: 'column' }}
            >
              <DSText as='p'>Endereço de entrega</DSText>
              <DSText as='strong' weight='bold'>
                {data.endereco.logradouro}, {data.endereco.numero} -{' '}
                {data.endereco.bairro}
              </DSText>
            </DSCol>
            <DSCol
              xs={12}
              lg={2}
              gap={1}
              css={{ display: 'flex', flexDirection: 'column' }}
            >
              <DSText as='p'>Agrupamento</DSText>
              <DSText as='strong' weight='bold'>
                {data.codigo}
              </DSText>
            </DSCol>
            <DSCol
              xs={12}
              lg={2}
              gap={1}
              css={{ display: 'flex', flexDirection: 'column' }}
            >
              <DSText as='p'>Status</DSText>
              <DSTag variant={variant.style}>{variant.label}</DSTag>
            </DSCol>
          </DSRow>
        </DSAccordion.Header>
        <DSAccordion.Content>
          <div
            ref={contentRef}
            role="presentation"
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
          >
            {isOpen && <DeliveryUnitsList key={openCount} delivery={data} />}
          </div>
        </DSAccordion.Content>
      </DSAccordion>
    </div>
  )
}
